import { createSlug, convertToKebabCase } from '../../utils/common';
import { TOI_IMAGE_DOMAIN } from '../../constants';

export const onError = e => {
  const fallbackSrc = `${TOI_IMAGE_DOMAIN}/photo/34824568.cms`;
  if (e.target.src === fallbackSrc) return;
  if (typeof window !== 'undefined') {
    fetch(
      `https://timesofindia.indiatimes.com/invalidphoto.cms?v=1&url=${
        window.location.href
      }&src=${encodeURIComponent(e.target.src)}`,
    );
  }
  e.target.onerror = null;
  e.target.src = fallbackSrc;
};
export const createImgUrl = (
  imgsize = 12345,
  msid = '47529300',
  width,
  resizemode = 4,
  height,
  alt,
  isInlineImage = false,
) => {
  const urlData = [];

  const imgname = alt && alt !== '' ? createSlug(alt) : msid;

  if (isInlineImage) {
    if (
      imgsize &&
      imgsize !== 12345 &&
      imgsize !== '12345' &&
      imgsize !== '98989898'
    ) {
      urlData.push(`${TOI_IMAGE_DOMAIN}/photo/imgsize-${imgsize},msid-${msid}`);
    } else {
      urlData.push(`${TOI_IMAGE_DOMAIN}/photo/msid-${msid}`);
    }
    return `${urlData.join(',')}/${imgname}.jpg`;
  }

  urlData.push(`${TOI_IMAGE_DOMAIN}/thumb/${msid}.jpg?photoid=${msid}`);
  if (imgsize && imgsize !== null && imgsize !== 'undefined') {
    urlData.push(`imgsize=${imgsize}`);
  }
  if (width) {
    urlData.push(`width=${width}`);
  }
  if (height) {
    urlData.push(`height=${height}`);
  }
  urlData.push(`resizemode=${resizemode}`);

  return `${urlData.join('&')}`;
};

export function getImageFromImageObject(imageData, isMobile = false) {
  //default should be placeholder image
  let imageUrl = null;

  if (typeof imageData !== 'object') {
    return imageUrl;
  }

  const imgsize = imageData.version || '97979797';
  try {
    if (
      imageData &&
      imageData.id &&
      imageData.id.toString().indexOf('&') !== -1
    ) {
      imageData.id = imageData.id.split('&')[0];
    }
  } catch (error) {
    console.error(error);
  }

  if (imageData.id && typeof parseInt(imageData.id, 10) === 'number') {
    imageUrl = createImgUrl(
      imgsize,
      imageData.id,
      imageData.width || '600',
      imageData.resizemode,
      imageData.height,
    );
  } else if (imageData.src || imageData.desktop_src) {
    imageUrl = isMobile
      ? imageData.src
      : imageData.desktop_src || imageData.src;
  }

  return imageUrl;
}

export const getImageName = image => {
  if (image.name) {
    return convertToKebabCase(image.name);
  }
  if (image.nameseo) {
    return image.nameseo;
  }
  return image.id;
};

export function createLeadImageUrl(
  imageData = {},
  height,
  resizemode = 4,
  imageName,
) {
  const tempheight =
    height && typeof height === 'string' && height.includes('height-')
      ? height
      : 'height-225';
  const cleanHeight = tempheight.replace(/,+/g, '');

  return `${TOI_IMAGE_DOMAIN}/thumb/msid-${imageData.id}${
    imageData.imagesize ? `,imgsize-${imageData.imagesize}` : ''
  },width-400,${cleanHeight},resizemode-${resizemode}/${imageName ||
    imageData.id}.jpg`;
}
